import http from "../axios";

let apiV1Auth = {
	baseUrl: '/api/v1/auth',
	get: async () => {
		return await http.get(apiV1Auth.baseUrl);
	},
	post: async () => {
		return await http.post(apiV1Auth.baseUrl + '/v2');
	},
	session: async () => {
		return await http.get(apiV1Auth.baseUrl + '/session');
	},
	google: async (credential) => {
		return await http.post(apiV1Auth.baseUrl + '/google', { credential });
	},
	logout: async () => {
		return await http.post(apiV1Auth.baseUrl + '/logout');
	}
}

export  { apiV1Auth }